import {
  WSAvatar,
  WSButton,
  WSDivider,
  WSFlexBox,
  WSGrid,
  WSInfoBox,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency, Payout, PayoutTransfer } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { useHistory } from "react-router-dom";
import {
  avatarBankAccount,
  avatarWallet
} from "../../../../shared/constants/avatars";

export const PayoutAccountDetailsItem: React.FC<{
  payoutAccountItem: PayoutTransfer;
  payout: Payout;
  isWallet?: boolean;
}> = props => {
  const history = useHistory();
  const payoutAccountItem = props.payoutAccountItem;
  const payout = props.payout;
  const isWallet = props.isWallet;
  const currency = (payout.currency ?? Currency.USD) as Currency;

  return (
    <WSPanel key={payoutAccountItem.fundsMovementId} mb={"L"} noBorder>
      <WSFlexBox mb="XL" justify="space-between">
        {isWallet ? (
          <WSFlexBox alignItems="center">
            <WSAvatar {...avatarWallet} mr="M" />
            <WSButton.Link
              size="M"
              name="viewRoutingNumber"
              onClick={() => history.push("/member/wallet")}
            >
              Wingspan Wallet
            </WSButton.Link>
          </WSFlexBox>
        ) : (
          <WSFlexBox alignItems="center">
            <WSAvatar {...avatarBankAccount} mr="M" />
            <WSText.ParagraphSm color={"gray500"} mr="2XL">
              {`${payoutAccountItem?.destination?.institutionName || ""} `}
            </WSText.ParagraphSm>
          </WSFlexBox>
        )}
      </WSFlexBox>

      <WSGrid gutter="2XL" mb={"L"}>
        <WSGrid.Item span={{ xs: "12", s: "6", l: "6" }}>
          <WSFlexBox direction="column">
            <WSText.ParagraphSm weight="book" mb="S" color="gray500">
              Account Number/Routing Number
            </WSText.ParagraphSm>
            <WSText.ParagraphSm weight="book" color="gray700">
              {`(...${payoutAccountItem?.destination?.mask || ""})`}
            </WSText.ParagraphSm>
          </WSFlexBox>
        </WSGrid.Item>

        <WSGrid.Item span={{ xs: "12", s: "6", l: "6" }}>
          <WSFlexBox direction="column">
            <WSText.ParagraphSm weight="book" mb="S" color="gray500">
              Payout amount
            </WSText.ParagraphSm>
            <WSText.ParagraphSm weight="book" color="gray700">
              {formatMoney(payoutAccountItem?.amount, currency)}
            </WSText.ParagraphSm>
          </WSFlexBox>
        </WSGrid.Item>

        <WSGrid.Item span={{ xs: "12", s: "6", l: "6" }}>
          <WSFlexBox direction="column">
            <WSText.ParagraphSm weight="book" mb="S" color="gray500">
              Statement description
            </WSText.ParagraphSm>
            <WSText.ParagraphSm weight="book" color="gray700">
              Wingspan Payout
            </WSText.ParagraphSm>
          </WSFlexBox>
        </WSGrid.Item>

        {payoutAccountItem.externalReference && (
          <WSGrid.Item span={{ xs: "12", s: "6", l: "6" }}>
            <WSFlexBox direction="column">
              <WSText.ParagraphSm weight="book" mb="S" color="gray500">
                Trace ID / reference #
              </WSText.ParagraphSm>
              <WSText.ParagraphSm weight="book" color="gray700">
                {payoutAccountItem.externalReference}
              </WSText.ParagraphSm>
            </WSFlexBox>
          </WSGrid.Item>
        )}
      </WSGrid>
      <WSDivider mb={"L"} />
      <WSText.ParagraphSm mb={"L"} weight="book" color="gray500">
        {`Payout • ${formatMoney(payoutAccountItem?.amount, currency)}`}
      </WSText.ParagraphSm>
      {payoutAccountItem.status && (
        <WSInfoBox mb={"L"}>
          <WSFlexBox alignItems="center">
            <WSText.ParagraphSm weight="book" color="gray700">
              {payoutAccountItem.status}
            </WSText.ParagraphSm>
          </WSFlexBox>
        </WSInfoBox>
      )}
    </WSPanel>
  );
};
